import { Component, OnInit, AfterViewInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { Router } from '@angular/router';
import { User } from 'app/shared/models/User';
import { SharedService } from 'app/shared/services/shared.service';



@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, AfterViewInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    userUrl: Router;
    user: User;

    isAdmin: boolean;
    isLender: boolean;



    constructor(
        private sharedService: SharedService
       
    ) {
    }

    ngOnInit() {
        this.sharedService.currentUser.subscribe(user => {
            this.user = user;
            this.isAdmin = user.isAdmin;
            this.isLender = user.isLender;
        });

        this.headerTitle = { title: 'Dashboard' };

    }

    ngAfterViewInit() {

    }

   
}
